import React from "react";
import { useNavigate } from "react-router-dom";
import { formatDateForDisplay } from "../utils/dateFormat"; // adjust path as needed
const Course = ({ form }) => {
  const navigate = useNavigate();

  function toFixedDigitFloat(n, noOfDigit, noOfDigitAfterDecimal) {
    let [intPart, decimalPart] = n.toFixed(noOfDigitAfterDecimal).split("."); // Ensures decimal part has fixed digits
    intPart = intPart.padStart(noOfDigit, "0"); // Zero-pad the integer part
    return `${intPart}.${decimalPart}`;
}

  const handleCardClick = () => {
   if(form.type==='gst')
   {
    navigate(`/gstbilldetailsAdmin/${form._id}`); 
   }
   else if(form.type==='retail')
    {
      navigate(`/gstbilldetailsAdmin/${form._id}`); 
    }
    else if(form.type==='cashmemo')
      {
        navigate(`/gstbilldetailsAdmin/${form._id}`); 
      }
      else{
        navigate(`/notypebill/${form._id}`); 
      }
   
  };

  const typeToGradientClass = {
  gst: "bg-gradient-to-r from-yellow-400 to-yellow-200",
  retail: "bg-gradient-to-r from-blue-400 to-blue-200",
  cashmemo: "bg-gradient-to-r from-pink-400 to-pink-200",
};
  return (
    <div
  onClick={handleCardClick}
  className={`
    w-[180px] h-[190px] shadow-lg rounded-2xl p-4 flex flex-col justify-center cursor-pointer
    transform transition duration-300 hover:scale-105 hover:shadow-xl hover:bg-gradient-to-r from-blue-400 to-blue-200
    ${typeToGradientClass[form.type] || "bg-gradient-to-r from-gray-300 to-gray-100"}
  `}
>  
<p className="w-full text-xs text-center font-semibold mb-[10px]"> {form.type.toUpperCase()}</p>
  <p className="w-full text-xs text-center mb-[4px]">{form.bill_number}</p>
  <p className="w-full text-xs text-center font-semibold mb-[10px]">
       {form.submission_status.toLowerCase() === "submitted" ? formatDateForDisplay(form.issue_date) : formatDateForDisplay(form.issue_date)}
    </p>

  <p className="w-full text-xs text-center mb-[10px] font-semibold">{form.name.length <= 30 ? form.name : `${form.name.slice(0, 30)}...`}</p>
  <p className="w-full text-xs text-center font-bold">
     {"₹"+toFixedDigitFloat(form.total_amount,1,2)}
  </p>
  <p className="w-full text-xs text-center font-semibold">
     {form.submission_status.toLowerCase() === "submitted"
  ? "Confirmed"
  : form.submission_status.toLowerCase() === "cancelled"
    ? "Cancelled"
    : "Yet to Confirm"}
    </p>
    
</div>
  );
};

export default Course;
